import React,{useEffect,useState} from 'react';
import { Container, Card } from 'react-bootstrap';
import { db } from '../FireBase';
import { collection, addDoc, doc, getDoc } from 'firebase/firestore';


const PrivacyAndPolicy = () => {

    const [contactInfo, setContactInfo] = useState({});
    useEffect(() => {
        fetchContactInfo();
      }, []);
    
      const fetchContactInfo = async () => {
        const docRef = doc(db, 'settings', 'contact');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setContactInfo(docSnap.data());
        }
      };
    
  return (
    <Container className="p-2" style={{ marginBottom: '40px' }}>
      <Card className="shadow rounded-4 p-4 border-0">
        <Card.Body>
          <h2 className="mb-4 text-center">Privacy Policy</h2>

          {/* <section className="mb-4">
            <h5>Effective Date</h5>
            <p>[Insert Date]</p>
          </section> */}

          <section className="mb-4">
            <p style={{ textAlign: 'justify' }}>
              At Kabili Holidays, accessible from <a href="https://kabiliholidays.com" target="_blank" rel="noopener noreferrer">https://kabiliholidays.com</a>, we are committed to protecting your privacy. This policy outlines how we collect, use, and safeguard your information.
            </p>
          </section>

          <section className="mb-4">
            <h5>1. Information We Collect</h5>
            <ul>
              <li>Personal Information: Name, email, phone number, ID details, etc.</li>
              <li>Booking Information: Check-in/check-out dates, accommodation type, guest preferences.</li>
              <li>Payment Information: Handled securely by third-party providers (we do not store card details).</li>
            </ul>
          </section>

          <section className="mb-4">
            <h5>2. How We Use Your Information</h5>
            <ul>
              <li>To process bookings and provide customer support</li>
              <li>To send booking confirmations, service updates, and promotional offers</li>
              <li>To improve our website, services, and user experience</li>
            </ul>
          </section>

          <section className="mb-4">
            <h5>3. Sharing Your Information</h5>
            <p>We do not sell or rent your data. We may share your information only with:</p>
            <ul>
              <li>Trusted partners for booking and payment processing</li>
              <li>Legal or regulatory authorities if required by law</li>
            </ul>
          </section>

          <section className="mb-4">
            <h5>4. Cookies</h5>
            <p>We use cookies to improve site functionality and analyze usage.</p>
          </section>

          <section className="mb-4">
            <h5>5. Your Rights</h5>
            <p>You may request to access, correct, or delete your data at any time by contacting us.</p>
          </section>

          <section className="mb-4">
            <h5>6. Contact Information</h5>
            <p style={{ whiteSpace: 'pre-wrap', textAlign: 'justify' }}>
              <strong>Address:</strong><br />{contactInfo.address}
            </p>
            <p style={{ textAlign: 'justify' }}>
              <strong>Mail:</strong> <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a><br />
              <strong>Phone:</strong> <a href={`tel:${contactInfo.phone}`}>{contactInfo.phone}</a>
            </p>
          </section>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default PrivacyAndPolicy;
